import inputeditform from '@/modules/form_builder/components/formsComponents/editForms/SingleFieldForm';
import textareaeditform from '@/modules/form_builder/components/formsComponents/editForms/SingleFieldForm';
import quantityeditform from '@/modules/form_builder/components/formsComponents/editForms/SingleFieldForm';
import selecteditform from '@/modules/form_builder/components/formsComponents/editForms/SelectForm';
import radiogroupeditform from '@/modules/form_builder/components/formsComponents/editForms/MultipleFieldsForm';
import datepickereditform from '@/modules/form_builder/components/formsComponents/editForms/SingleFieldForm';
import checkboxgroupeditform from '@/modules/form_builder/components/formsComponents/editForms/MultipleFieldsForm';
import timepickereditform from '@/modules/form_builder/components/formsComponents/editForms/SingleFieldForm';
import { LIST } from '@/modules/form_builder/components/mixins/components-list';

export default {
  components: {
    inputeditform,
    textareaeditform,
    quantityeditform,
    selecteditform,
    radiogroupeditform,
    datepickereditform,
    checkboxgroupeditform,
    timepickereditform
  },

  data: () => ({
    elements: LIST
  }),

  methods: {
    formName(type) {
      return type + 'editform';
    }
  }
};
